import type { IWarehouseRepository } from '../domain/IWarehouseRepository'
import type { Warehouse } from '../domain/warehouse'

export class AddWarehouseUseCase {
    constructor(private warehouseRepository: IWarehouseRepository) {}

    async execute(data: Warehouse): Promise<Warehouse> {
        // Validaciones de negocio
        if (!data.name || data.name.trim() === '') {
            throw new Error('El nombre del warehouse es requerido')
        }

        if (!data.address || data.address.trim() === '') {
            throw new Error('La dirección es requerida')
        }

        if (!data.city || data.city.trim() === '') {
            throw new Error('La ciudad es requerida')
        }

        if (!data.id) {
            throw new Error('El ID de la empresa es requerido')
        }

        return await this.warehouseRepository.addWarehouse(data)
    }
}
